import React, { useContext, useState } from 'react'
import { Grid } from 'semantic-ui-react'
import InputField from '../../../commonComponents/formComponents/inputField'
import { useSelector } from 'react-redux'
import { CommodityField } from '../../../commonComponents/formComponents/CommodityCodeField'
import { useCurrentShipmentType } from '../../../hooks/useCurrentShipmentType'
import { TranslateContext } from '../../../NL_App/formSections/TranslateContext'
import CommonAdditionalCode from './commonAdditionalCode'


const MerchForm2=({
  isFormDisabled,
  merchandiseId,
  updateData,
  saveData,
  saveCommodityCode,
  invoiceId,
  lineNumber,
  invoiceItemIndex,
  fieldPattern,
  validateError,
}) =>{

  const [htsMetaData, setHtsMetaData] = useState({})
  const [showModal, setShowModal] = useState(false)
  const commodityCodeDescription=useSelector((state)=>state.InvoicesReducer.invoice.merchandise[merchandiseId]?.commodityCodeDescription)
  const euAdditionalCode=useSelector((state)=>state.InvoicesReducer.invoice.merchandise[merchandiseId]?.euAdditionalCode)
  const commodityCode=useSelector((state)=>state.InvoicesReducer.invoice.merchandise[merchandiseId]?.commodityCode || "")
  const taricCode=useSelector((state)=>state.InvoicesReducer.invoice.merchandise[merchandiseId]?.taricCode||"")
  const { declarationCat = '' } = useSelector((state) => state.Shipment) || []
  const commodityCodeErr = useSelector((state)=>state?.ValidationErrors.items?.[`invoice${invoiceItemIndex+1}_lineItem${lineNumber}_commodityCode`]) 
  const originCountry=useSelector((state)=>state.InvoicesReducer.invoice.merchandise[merchandiseId]?.originCountry)

  

  const { isImportShipment, serviceType } = useCurrentShipmentType()
  const {translate}=useContext(TranslateContext)
  return (
    <Grid.Row>
      <CommodityField
         taricLabel="Taric code"
         taricWidth={2}
         htsWidth={3}
         htsBoxNumber="6/14"
         taricBoxNumber={serviceType==="IM" ? "6/15" :''}
         translate={translate}
         isFormDisabled={isFormDisabled}
         serviceType={serviceType}
         isImportShipment={isImportShipment}
         commodityCode={commodityCode}
         htsCode={serviceType=="IM"?commodityCode+taricCode:commodityCode}
         taricCode={taricCode}
         merchandiseId={merchandiseId}
         invoiceId={invoiceId}
         htsMetaData={htsMetaData} // always blank need to discuss
         showModal={showModal}
         setShowModal={setShowModal}
         errors={serviceType === 'EX' && commodityCodeErr && commodityCodeErr?.msg}
         onHtsChange={(value) =>{
          let hts = value.length > 8 ? value.slice(0, 8) : value
          let taric = value.length > 8 ? value.slice(8) : ''
          updateData({ commodityCode: hts, taricCode: taric })}
        }
         onHtsPopupChange={({taricCode,htsCode}) => {
            updateData({commodityCode:htsCode,taricCode})
            saveCommodityCode({commodityCode:htsCode || " ",taricCode})
            const key = `invoice${invoiceItemIndex + 1}_lineItem${lineNumber}_commodityCode`
            validateError(
              { [key]: '' },
              { [key]: htsCode },
              { [key]: fieldPattern({declarationCat}).items?.lineItem(invoiceItemIndex + 1, lineNumber)?.commodityCode }
            )
         }}
         onBlur={() => {
          if(commodityCode.length>=8){
            saveCommodityCode({commodityCode:commodityCode || " ",taricCode})
            const key = `invoice${invoiceItemIndex + 1}_lineItem${lineNumber}_commodityCode`
            validateError(
              { [key]: '' },
              { [key]: commodityCode },
              { [key]: fieldPattern({declarationCat}).items?.lineItem(invoiceItemIndex + 1, lineNumber)?.commodityCode }
            )
           }
          }
        }
         copyFeature={true}
         countryOfOrigin={originCountry}
       />
      <CommonAdditionalCode 
      isFormDisabled={isFormDisabled}
      tableName={"euAdditionalCode"}
      invoiceId={invoiceId}
      merchandiseId={merchandiseId}
      boxNumber="6/16"
      />

     <CommonAdditionalCode 
      isFormDisabled={isFormDisabled}
      tableName={"ukAdditionalCode"}
      invoiceId={invoiceId}
      merchandiseId={merchandiseId}
      boxNumber="6/17"
      />

        <Grid.Column width='3' className='divFormFeild'>

           <InputField
          isLabel={false}
          id={`commodityCode-${invoiceId}-${merchandiseId}`}
          type='text'
          mandatory={false}
          clearInput={false}
          label='COMMODITY CODE DESCRIPTION'
          value={commodityCodeDescription}
          className='field-bg'
          disabled={isFormDisabled}
          onChange={(value) =>updateData({commodityCodeDescription:value})}
          onBlur={(value) =>saveData({commodityCodeDescription:commodityCodeDescription || " "})}
        />
          
        </Grid.Column>
      
    </Grid.Row>
  )
}

export default React.memo(MerchForm2)
